import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {IssueStatus} from "../../domain/entities/issue-status.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityChangedPayload} from "../../message-broker/payloads/entity-changed.payload";
import {CommandBus} from "../../services/command-bus.service";
import {RecolorIssueStatusCommand} from "../recolor-issue-status.command";
import {ICommandHandler} from "./i-command.handler";

/**
 * Handles recoloring an issue status by sending the command
 * to the backend and publishing a local entity changed event.
 */
@CommandHandler(RecolorIssueStatusCommand)
@singleton()
export class RecolorIssueStatusCommandHandler implements ICommandHandler<IssueStatus> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker,
    ) {
    }

    /**
     * Sends the recolor command to the backend and publishes an entity changed event.
     */
    public async handle(command: RecolorIssueStatusCommand): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }
        const issueStatus = command.payload;
        this._messageBroker.publish<EntityChangedPayload<IssueStatus>>({
            type: `entity.changed`,
            identityHash: issueStatus.uid,
            payload: {
                uid: issueStatus.uid,
                prototype: IssueStatus,
                changeSet: issueStatus.changeSet
            }
        });
        issueStatus.markAsPersisted();
    }
}
